/**
 * @generated SignedSource<<50e483a80348637b440e47492b9dc595>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* eslint-disable */

'use strict';

var node = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "answers"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "contributionId"
},
v2 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "email"
},
v3 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "emailConsent"
},
v4 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "emailTrackingConsent"
},
v5 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "name"
},
v6 = [
  {
    "kind": "Variable",
    "name": "answers",
    "variableName": "answers"
  },
  {
    "kind": "Variable",
    "name": "contributionId",
    "variableName": "contributionId"
  },
  {
    "kind": "Variable",
    "name": "email",
    "variableName": "email"
  },
  {
    "kind": "Variable",
    "name": "emailConsent",
    "variableName": "emailConsent"
  },
  {
    "kind": "Variable",
    "name": "emailTrackingConsent",
    "variableName": "emailTrackingConsent"
  },
  {
    "kind": "Variable",
    "name": "name",
    "variableName": "name"
  }
],
v7 = {
  "kind": "InlineFragment",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "success",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "notice",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "needsAuthentication",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "ValidationError",
      "kind": "LinkedField",
      "name": "errors",
      "plural": true,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "field",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "messages",
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "MutationResult",
  "abstractKey": "__isMutationResult"
},
v8 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
},
v9 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "email",
  "storageKey": null
},
v10 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "isUser",
  "storageKey": null
},
v11 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "avatarUrl",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/),
      (v3/*: any*/),
      (v4/*: any*/),
      (v5/*: any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "AnonymousUserAuthMutation",
    "selections": [
      {
        "alias": null,
        "args": (v6/*: any*/),
        "concreteType": "AnonymousUserAuthPayload",
        "kind": "LinkedField",
        "name": "anonymousUserAuth",
        "plural": false,
        "selections": [
          (v7/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "AnonymousUser",
            "kind": "LinkedField",
            "name": "viewer",
            "plural": false,
            "selections": [
              (v8/*: any*/),
              (v9/*: any*/),
              (v10/*: any*/),
              (v11/*: any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v2/*: any*/),
      (v3/*: any*/),
      (v4/*: any*/),
      (v5/*: any*/),
      (v1/*: any*/)
    ],
    "kind": "Operation",
    "name": "AnonymousUserAuthMutation",
    "selections": [
      {
        "alias": null,
        "args": (v6/*: any*/),
        "concreteType": "AnonymousUserAuthPayload",
        "kind": "LinkedField",
        "name": "anonymousUserAuth",
        "plural": false,
        "selections": [
          (v7/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "AnonymousUser",
            "kind": "LinkedField",
            "name": "viewer",
            "plural": false,
            "selections": [
              (v8/*: any*/),
              (v9/*: any*/),
              (v10/*: any*/),
              (v11/*: any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "id",
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "d5ec87c022d3af3808a50f2cab5d6cf5",
    "id": null,
    "metadata": {},
    "name": "AnonymousUserAuthMutation",
    "operationKind": "mutation",
    "text": "mutation AnonymousUserAuthMutation(\n  $answers: [AnswerInput]\n  $email: String\n  $emailConsent: Boolean\n  $emailTrackingConsent: Boolean\n  $name: String!\n  $contributionId: ID\n) {\n  anonymousUserAuth(answers: $answers, email: $email, emailConsent: $emailConsent, emailTrackingConsent: $emailTrackingConsent, name: $name, contributionId: $contributionId) {\n    ... on MutationResult {\n      __isMutationResult: __typename\n      success\n      notice\n      needsAuthentication\n      errors {\n        field\n        messages\n      }\n    }\n    viewer {\n      name\n      email\n      isUser\n      avatarUrl\n      id\n    }\n  }\n}\n"
  }
};
})();

node.hash = "ccaace8a5afca685d831527c2176524c";

module.exports = node;
